import React from 'react';
import Button from './Button';
import styles from './StudentWelcome.module.css';

function ApplySection({ completedSteps, navigateToDashboard }) {
  return (
    <section className={styles.applySection}>
      <h2 className={styles.sectionTitle}>Start Applying</h2>
      <Button
        className={`${styles.applyButton} ${completedSteps.size < 3 ? styles.disabled : ''}`}
        style={{ backgroundColor: '#061941', color: 'white' }} // Inline style as a backup
        onClick={() => completedSteps.size >= 3 && navigateToDashboard()}
        disabled={completedSteps.size < 3}
      >
        Find a Program
      </Button>
    </section>
  );
}

export default ApplySection;